import React from 'react';
import { SvgIconProps } from '../types';

export default function Member({
  fill,
  width,
  height,
  className,
  ariaLabel,
  ariaHidden,
}: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      fill="none"
      width={width}
      height={height}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <g clip-path="url(#clip0_20708_74888)">
        <path
          d="M25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0Z"
          fill={fill}
        />
        <path
          d="M41.0229 29.2679C41.6667 29.4206 42.1513 29.9483 42.1513 30.6087V34.5248C42.1513 35.3246 41.5008 35.9751 40.701 35.9751H9.30246C8.50264 35.9751 7.85217 35.3246 7.85217 34.5248V30.6087C7.85217 29.9483 8.33671 29.4206 8.98054 29.2679C11.151 28.7602 12.7672 26.8088 12.7672 24.4823C12.7672 22.1559 11.151 20.2078 8.98054 19.6967C8.33671 19.5441 7.85217 19.0164 7.85217 18.356V15.4687C7.85217 14.6688 8.50264 14.0184 9.30246 14.0184H40.6977C41.4975 14.0184 42.1479 14.6688 42.1479 15.4687V18.356C42.1479 19.0164 41.6634 19.5441 41.0196 19.6967C38.8491 20.2045 37.2329 22.1559 37.2329 24.4823C37.2329 26.8088 38.8491 28.7569 41.0196 29.2679H41.0229ZM32.2183 26.5333L28.8863 23.2478C28.8299 23.1947 28.8066 23.115 28.8199 23.0387L29.6363 18.4323C29.6695 18.2398 29.4704 18.0905 29.2945 18.1801L25.1428 20.3339C25.0731 20.3704 24.9901 20.3704 24.9237 20.3339L20.7952 18.1336C20.6226 18.0407 20.4202 18.1867 20.4501 18.3792L21.2167 22.9955C21.23 23.0719 21.2034 23.1515 21.147 23.2046L17.7785 26.4503C17.6391 26.5864 17.7121 26.8254 17.9079 26.8519L22.5342 27.5522C22.6106 27.5621 22.6769 27.6119 22.7101 27.6816L24.7578 31.8897C24.8441 32.0656 25.093 32.0656 25.1826 31.8897L27.2767 27.7048C27.3099 27.6351 27.3796 27.5887 27.4559 27.5754L32.0889 26.9282C32.2813 26.9017 32.361 26.6627 32.2216 26.5267L32.2183 26.5333Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_20708_74888">
          <rect width="50" height="50" fill="white" transform="matrix(1 0 0 -1 0 50)" />
        </clipPath>
      </defs>
    </svg>
  );
}
